import { CAMPAIGN_CADENCES_TYPE_TAB_KEY } from '../constants/campaignCadencesTabs';

export function getCampaignCadenceKey({ typeTab, campaignId, channel }) {
  if (typeTab === CAMPAIGN_CADENCES_TYPE_TAB_KEY.TRIGGERS) {
    return `${typeTab}_${channel}`;
  }
  return `${typeTab}_${campaignId}_${channel}`;
}
